const TAPDB_SCRIPT_URL = 'https://website.xdcdn.net/module/tapdb.umd.min.js'

const createTapdbConfig = () => ({
  appId: 'sausage',
  serverUrl: 'https://tapdb-one-data-sdk-bj.cn-beijing.log.aliyuncs.com/logstores/tapdb-web/track',
  isUseSLS: true,
  textContent: 'json',
  autoTrack: {
    pageShow: true,
    pageHide: true
  }
})

export const useTapdb = (uiStore) => {
  let initialized = false

  const afterLoadDB = () => {
    if (initialized || typeof tapdb === 'undefined') return

    initialized = true
    tapdb.init(createTapdbConfig())
    uiStore.setCurrentPage('', { track: true })
    tapdb.pvEvent()
  }

  const initTapdb = () => {
    if (typeof document === 'undefined') return

    if (typeof tapdb !== 'undefined') {
      afterLoadDB()
      return
    }

    const existingScript = document.querySelector(`script[src="${TAPDB_SCRIPT_URL}"]`)
    if (existingScript) {
      existingScript.addEventListener('load', afterLoadDB, { once: true })
      return
    }

    const head = document.head || document.documentElement
    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('src', TAPDB_SCRIPT_URL)
    script.onload = afterLoadDB
    script.onreadystatechange = function onReadyStateChange() {
      if (this.readyState === 'loaded' || this.readyState === 'complete') {
        afterLoadDB()
      }
    }
    head.appendChild(script)
  }

  return {
    initTapdb
  }
}
